import type { InMemoryStorage } from './InMemoryStorage';
import InMemoryStorageAPI from './InMemoryStorage';

export default class QLocalStorage {
  private storage: Storage | InMemoryStorage;

  private isProd: boolean;

  constructor(isProd: boolean) {
    this.isProd = isProd;
    if (QLocalStorage.isAvailable()) {
      this.storage = window.localStorage;
    } else {
      this.storage = new InMemoryStorageAPI();
    }
  }

  private static isAvailable() {
    if (typeof window !== 'undefined' && window.localStorage) {
      return true;
    }
    return false;
  }

  getItem(key: string, options: { parseJSON: boolean } = { parseJSON: true }) {
    try {
      const val = this.storage.getItem(key);

      if (!options.parseJSON) {
        return val;
      }

      return JSON.parse(val as string);
    } catch (error) {
      if (!this.isProd) {
        // eslint-disable-next-line no-console
        console.error(
          `Error at LocalStorage "getItem" in q-analytics: for key(${key})`,
          error,
        );
      }
    }
  }

  setItem(key: string, value: any, options: { storeAsJSON: boolean } = { storeAsJSON: true }) {
    try {
      const valToStore = options.storeAsJSON
        ? JSON.stringify(value)
        : value;
      return this.storage.setItem(key, valToStore);
    } catch (error) {
      if (!this.isProd) {
        // eslint-disable-next-line no-console
        console.error(
          `Error at LocalStorage "setItem" in q-analytics: for key(${key})`,
          error,
        );
      }
    }
  }

  removeItem(key: string) {
    return this.storage.removeItem(key);
  }

  clear() {
    return this.storage.clear();
  }
}
